import { I18nLabelProvider } from "@client/context/i18n";
import { globals } from "@client/globals";
import appInfo from "@common/appInfo";
import AiChat from "@common/components/AiChat/component";
import { type AiChatApi } from "@common/components/AiChat/types";
import { useI18n } from "@common/hooks/i18n";
import apiV1 from "@common/lib/api";
import { usePromise } from "@common/lib/hooks";
import React from "react";

import "./style.less";

export default () => {
  const i18n = useI18n();

  const api = React.useMemo(
    (): AiChatApi => ({
      agents: {
        get: () => apiV1.get(i18n, `/api/site/v1/ai/agents/${appInfo.ai.agentId}`)
      },
      chats: {
        getAll: () => Promise.resolve([]),
        sendMessage: (id, data) => apiV1.post(i18n, `/api/site/v1/ai/chats/${id}/sendMessage`, data)
      },
      chatMessages: {
        getAll: (id) => apiV1.get(i18n, `/api/site/v1/ai/chats/${id}/messages`)
      }
    }),
    [i18n]
  );

  // NOTE: SSR must render nothing because AiChat uses localStorage
  const [ready] = usePromise({
    fn: () => Promise.resolve(true),
    args: [],
    shouldLoad: !!appInfo.ai.agentId && globals.mode === "app"
  });

  if (!ready) return null;

  return (
    <I18nLabelProvider category="AIChat">
      <AiChat api={api} modalClassName="site_font" modalTitle={i18n.chat} />
    </I18nLabelProvider>
  );
};
